import React from "react";

const RepresentingGrowers = () => {
  return (
    <section className="relative py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed opacity-10"
        style={{ 
          backgroundImage: 'url("/lovable-uploads/ea1935c4-f503-4861-ad89-f6a11e87af8b.png")',
        }}
      />
      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-primary">Representing Growers</h2>
          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl border border-primary/20">
            <p className="text-lg leading-relaxed text-gray-700">
              Represent the views of seed potato grower members and present evidence to government bodies.
              As we grow we are focused on developing partnerships across the industry to support our members 
              with cutting-edge research, collaborative initiatives, and advocacy efforts, promoting sustainable 
              and prosperous practices within the potato farming community.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RepresentingGrowers;